<template>
  <div class="category-filter">
    <div class="select-filter">
      <select-dropdown-sort
        :items="sorters"
        v-model="selectValue"
        name="Sort by"
      />
      </div>
      <div class="chevron">
        <a
          href="javascript:"
          :class="{ reversed: this.sortDirection === 'DESC' }"
          class="chevron-icon"
          @click="changeDirection">

        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100" height="100" viewBox="0 0 100 100"><g><g transform="translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)" style="fill:#1A1A1A"><svg fill="#1A1A1A" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" x="0px" y="0px" viewBox="0 0 100 100"><g transform="translate(0,-952.36218)"><path style="text-indent:0;text-transform:none;direction:ltr;block-progression:tb;baseline-shift:baseline;color:#000000;enable-background:accumulate;" d="m 50.406266,1024.426 a 5.0005,5.0005 0 0 0 2.87497,-1.2188 l 39,-33.99995 a 5.0005,5.0005 0 1 0 -6.5625,-7.5313 l -35.71877,31.12495 -35.7187,-31.12495 a 5.0005,5.0005 0 1 0 -6.5624999,7.5313 l 38.9999999,33.99995 a 5.0005,5.0005 0 0 0 3.6875,1.2188 z" fill="#1A1A1A" fill-opacity="1" stroke="none" marker="none" visibility="visible" display="inline" overflow="visible"></path></g></svg></g></g></svg>

        </a>
      </div>
  </div>
</template>

<script>
import SelectDropdownSort from '../../components/ui-elements/select-dropdown-sort'

export default {
  name: 'generic-sorting',
  components: {
    'select-dropdown-sort': SelectDropdownSort
  },
  props: {
    'sorters': {
      type: Array,
      required: true
    },
    'value': {
      type: Object,
      default: ''
    }
  },
  computed: {
    selectValue: {
      get () {
        return this.value.sorters
      },
      set (value) {
        this.value.sorters = value
        this.$emit('input', this.value)
      }
    },
    sortDirection: {
      get () {
        return this.value.sortDir.toUpperCase()
      },
      set (value) {
        this.value.sortDir = value
        this.$emit('input', this.value)
      }
    }
  },
  methods: {
    changeDirection () {
      if (this.sortDirection === 'ASC') {
        this.sortDirection = 'DESC'
      } else {
        this.sortDirection = 'ASC'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.category-filter {
  display: flex;

  .select-filter {
    flex: 2;
  }

  .chevron {
    font-size: 2em;
    display: flex;
    flex-direction: column;
    justify-content: center;

    a {
      color: var(--main-primary);
      transition: var(--main-transition);
      justify-content: center;
      align-items: center;
      display: flex;
      &.chevron-icon {
        transform-origin: center;
        svg {
          width:1em;
          height:1em;
        }
        &.reversed {
        transform: rotate(180deg);
        }
      }

      &:hover {
        color: var(--main-secondary) !important;
      }
    }
  }
}

</style>
